"use client";
import ThemeLink from "@/components/link";
import {Placeholder} from "@/components/placeholder";
import { contactInfo } from "@/lib/api/contacts";

const leftContent = [{
    title: "购物指南",
    children: [{
        title: "顾客须知",
        href: ""
    }, {
        title: "购物流程",
        href: ""
    }]
}, {
    title: "配送方式",
    children: [{
        title: "快递运输",
        href: ""
    }, {
        title: "上门自提",
        href: ""
    }]
}, {
    title: "支付方式",
    children: [{
        title: "在线支付",
        href: ""
    }, {
        title: "发票须知",
        href: ""
    }]
}, {
    title: "售后服务",
    children: [{
        title: "申请退/换货",
        href: ""
    }, {
        title: "退款说明",
        href: ""
    }, {
        title: "取消购买",
        href: ""
    }]
}, {
    title: "帮助中心",
    children: [{
        title: "帮助中心",
        href: ""
    }, {
        title: "常见问题",
        href: ""
    }]
}, {
    title: "关于我们",
    children: [{
        title: "关于恒配达",
        href: ""
    }, {
        title: "联系我们",
        href: ""
    }]
}];

export default  function FooterContent() {
    return <div className="my-5 py-8 border-y-[1px]">
        <div className="grid grid-cols-2">
            <div className={`grid grid-cols-6 gap-x-4 border-r-[1px]`}>
                {
                    leftContent.map((item, index) => {
                        return <div key={index}>
                            <p className="font-bold text-[16px]">{item.title}</p>
                            <ul className="space-y-1 py-1 mt-3">
                                {
                                    item.children.map((c, cIndex) => {
                                        return <li key={cIndex}>
                                            <ThemeLink href={c.href} className="!text-sm">
                                                {c.title}
                                            </ThemeLink>
                                        </li>;
                                    })
                                }
                            </ul>
                        </div>;
                    })
                }
            </div>
            <div className="grid grid-cols-2 gap-x-4 ml-12">
                <div>
                    <p className="font-bold text-[16px]">联系我们</p>
                    <ul className="space-y-2 py-1 mt-3">
                        <li className="s-flex gap-x-1">
                            <p className="text-sm text-themeP">服务热线:</p>
                            <ThemeLink href={`tel:${contactInfo.Tel}`} className="!text-sm">{contactInfo.Tel}</ThemeLink>
                        </li>
                        <li className="s-flex gap-x-1">
                            <p className="text-sm text-themeP">技术支持:</p>
                            <ThemeLink href={`tel:${contactInfo.phone}`} className="!text-sm">{contactInfo.phone}</ThemeLink>
                        </li>
                        <li className="s-flex gap-x-1">
                            <p className="text-sm text-themeP">邮箱:</p>
                            <ThemeLink href={`mailto:${contactInfo.email}`} className="!text-sm">{contactInfo.email}</ThemeLink>
                        </li>
                        <li className="s-flex gap-x-1">
                            <p className="text-sm text-themeP">地址:</p>
                            <ThemeLink target="_blank"
                                       href="https://map.qq.com/?type=marker&isopeninfowin=1&markertype=1&pointx=113.654&pointy=22.8727&name=%E4%B8%9C%E8%8E%9E%E5%B8%82%E9%BC%8E%E5%9D%9A%E7%B2%BE%E5%AF%86%E4%BC%A0%E5%8A%A8%E6%9C%BA%E6%A2%B0%E6%9C%89%E9%99%90%E5%85%AC%E5%8F%B8(%E7%99%BD%E6%BF%A0%E6%BA%90%E5%85%B4%E8%A5%BF%E8%A1%97)&addr=%E5%8E%9A%E8%A1%97%E9%95%87%E7%99%BD%E6%BF%A0%E7%A5%A5%E5%85%B4%E8%A1%97%E8%A5%BF18%E5%B7%B76%E5%8F%B7%E5%8E%82%E6%88%BF&ref=WeChat"
                                       className="!text-sm">{contactInfo.address}</ThemeLink>
                        </li>
                        <li className="s-flex gap-x-1">
                            <p className="text-sm text-themeP">服务热线:</p>
                            <ThemeLink href={`tel:${contactInfo.Tel}`} className="!text-sm">{contactInfo.Tel}</ThemeLink>
                        </li>
                    </ul>
                </div>
                {/* <div className="c-flex flex-col">
                    <div className="relative">
                        <Placeholder src="/site/app-xiazai.png" imageWidth={200} imageHeight={200}/>
                        <div className="absolute inset-0 c-flex">
                            <Placeholder src="/site/logo.png" imageWidth={50} imageHeight={50}/>
                        </div>
                    </div>
                    <p className="font-bold text-[16px]">扫码进入手机商城</p>
                </div> */}
            </div>
        </div>
    </div>;
}
